import React, { useState } from 'react';
import { Send } from 'lucide-react';

const Newsletter = ({ settings }) => {
    const {
        title = "Subscribe to our emails",
        subtitle = "Be the first to know about new collections and exclusive offers.",
        buttonText = "Subscribe",
        bg,
        titleColor,
        subtitleColor,
        inputBg,
        inputText,
        inputBorder,
        inputRadius,
        buttonBg,
        buttonTextColor,
        buttonRadius,
        inputFocusColor,
        placeholderColor
    } = settings;

    const [email, setEmail] = useState('');
    const [status, setStatus] = useState(''); // 'loading', 'success', 'error'

    const handleSubmit = (e) => {
        e.preventDefault();
        if (!email) return;

        setStatus('loading');

        // Simulate API call
        setTimeout(() => {
            setStatus('success');
            setEmail('');
            setTimeout(() => setStatus(''), 3000);
        }, 1000);
    };

    return (
        <div
            className="w-full py-20 px-4"
            style={{
                backgroundColor: bg || 'var(--store-card-bg)',
                color: 'var(--store-text)'
            }}
        >
            <div className="max-w-3xl mx-auto text-center">
                <h2
                    className="text-3xl md:text-4xl font-bold mb-4 tracking-tight"
                    style={{ color: titleColor || 'inherit' }}
                >
                    {title}
                </h2>
                <p
                    className="mb-10 text-lg leading-relaxed"
                    style={{ color: subtitleColor || 'var(--store-muted)' }}
                >
                    {subtitle}
                </p>

                <form onSubmit={handleSubmit} className="flex flex-row md:flex-col gap-3 max-w-md mx-auto relative">
                    <style>
                        {`
                            .newsletter-input::placeholder {
                                color: ${placeholderColor || 'var(--store-muted)'} !important;
                                opacity: 1;
                            }
                        `}
                    </style>
                    <div className="relative flex-1">
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            className="newsletter-input w-full border px-6 py-3 transition-colors focus:outline-none focus:ring-1"
                            style={{
                                backgroundColor: inputBg || 'var(--store-input-bg)',
                                color: inputText || 'var(--store-input-text)',
                                borderColor: inputBorder || 'var(--store-input-border)',
                                borderRadius: inputRadius !== undefined ? `${inputRadius}px` : 'var(--store-input-radius, 20px)',
                                '--tw-ring-color': inputFocusColor || 'var(--store-input-focus)'
                            }}
                            required
                        />
                    </div>
                    <button
                        type="submit"
                        disabled={status === 'loading' || status === 'success'}
                        className="px-8 py-3 font-medium transition-all flex items-center justify-center gap-2 hover:opacity-90 disabled:opacity-100"
                        style={{
                            backgroundColor: status === 'success' ? '#22c55e' : (buttonBg || 'var(--store-button-bg)'),
                            color: status === 'success' ? '#ffffff' : (buttonTextColor || 'var(--store-button-text)'),
                            borderRadius: buttonRadius !== undefined ? `${buttonRadius}px` : 'var(--store-button-radius, 100px)'
                        }}
                    >
                        {status === 'loading' ? (
                            <span className="w-5 h-5 border-2 border-[var(--store-button-text)] border-t-transparent rounded-full animate-spin"></span>
                        ) : status === 'success' ? (
                            'Subscribed!'
                        ) : (
                            <>
                                {buttonText}
                            </>
                        )}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Newsletter;
